import { createSelector } from 'reselect';

import getCurrentOrder from './getCurrentOrder';

export default createSelector(
  [getCurrentOrder],
  currentOrder => currentOrder.receiptType,
);
